// if(document.querySelectorAll('.variant-wrapper label')) document.querySelectorAll('.variant-wrapper label').forEach(function(variant_click){
//   variant_click.addEventListener('click', function(e){
//     e.preventDefault();
//     if(window.innerWidth <= 991){
//       console.log('changes 2222');
//       variant_click.closest('.variant-wrapper').classList.add('active');
//       // const addButton = document.querySelector('#product-form-'+document.querySelector('variant-radios').getAttribute('data-section')+' [name="add"]');
//       // console.log('activedddd',document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper.active'));
//       // if(document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper.active')){
//       //   console.log('addButton',addButton);
//       //   if(addButton){
//       //     console.log('clickedd');
//       //     addButton.click();
//       //   }
//       // }
//       // variant_click.classList.add('active');
//       // const addButton = document.querySelector('#product-form-'+document.querySelector('variant-radios').getAttribute('data-section')+' [name="add"]');
//       // console.log('activedddd',document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked').classList.contains('active'));
//       // if(document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked').classList.contains('active')){
//       //   console.log('addButton',addButton);
//       //   if(addButton){
//       //     console.log('clickedd');
//       //     addButton.click();
//       //   }
//       // }
//     }
//   });
// });
class VariantRadios extends HTMLElement{
  constructor() {
    super();
    this.currentVariant = null;
    this.addEventListener('change', this.onVariantChange);
    this.setupHoverInventoryCheck();
    this.initializeCurrentVariant();
  }
  initializeCurrentVariant(){
    let variantData = this.getVariantData();
    if(variantData && variantData.length > 0){
      this.currentVariant = variantData[0];
    }
  }
  setupHoverInventoryCheck(){
    let variants = this.querySelectorAll('.variant-wrapper label');
    const isStaticUSPs = document.body.classList.contains('template-product.static_usps');
    
    variants.forEach((variant) => {
      // Desktop behavior
      if (!isStaticUSPs) {
        // Normal desktop: mouseover/mouseout behavior
        variant.addEventListener('mouseover', (event) => {
          this.checkInventoryOnHover(event.target);
        });
        variant.addEventListener('mouseout', () => {
          if(document.querySelector('.prod-low-stock')) document.querySelector('.prod-low-stock').classList.remove('active');
          if(document.querySelector('.prod-back-stock')) document.querySelector('.prod-back-stock').classList.remove('active');
        });
      }
      
      // Click behavior for A/B test or mobile
      variant.addEventListener('click', (event) => {
        if (isStaticUSPs || window.innerWidth <= 991) {
          this.checkInventoryOnHover(event.target);
          
          // Only add timeout for mobile without static_usps
          if (!isStaticUSPs && window.innerWidth <= 991) {
            setTimeout(() => {
              if(document.querySelector('.prod-low-stock')) document.querySelector('.prod-low-stock').classList.remove('active');
              if(document.querySelector('.prod-back-stock')) document.querySelector('.prod-back-stock').classList.remove('active');
            }, 10000);
          }
        }
      });
    });
  }
  checkInventoryOnHover(label){
    const input = label.closest('.variant-wrapper').querySelector('input');
    const variantWrapper = label.closest('.variant-wrapper');
    if(!variantWrapper) return;
    if(variantWrapper.classList.contains('variant-unavailable')) {
      if(document.querySelector('.prod-back-stock')) document.querySelector('.prod-back-stock').classList.add('active');
      if(document.querySelector('.prod-low-stock')) document.querySelector('.prod-low-stock').classList.remove('active');
    }else if(parseInt(variantWrapper.getAttribute('data-inventory')) < 3) {
      if(document.querySelector('.prod-low-stock')) document.querySelector('.prod-low-stock').classList.add('active');
      if(document.querySelector('.prod-back-stock')) document.querySelector('.prod-back-stock').classList.remove('active');
    }else{
      if(document.querySelector('.prod-low-stock')) document.querySelector('.prod-low-stock').classList.remove('active');
      if(document.querySelector('.prod-back-stock')) document.querySelector('.prod-back-stock').classList.remove('active');
    }
  }
  onVariantChange(){
    console.log('changes 111');
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if(!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else{
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();


      // if(this.currentVariant.available && window.innerWidth <= 991){
      //   const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
      //   console.log(this.querySelector('.option-wrap[data-name="Size"] .variant-wrapper.active input:checked').classList.contains('active'),'addedddddd');
      //   if(this.querySelector('.option-wrap[data-name="Size"] .variant-wrapper.active input:checked').classList.contains('active')){
      //     if(addButton){
      //       addButton.click();
      //     }
      //   }
      // }
      
      if(this.currentVariant.available && window.innerWidth <= 991){
        const addButton = document.querySelector(`#product-form-${this.dataset.section} [name="add"]`);
        // this.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked').classList.add('active');
        // if(this.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked').classList.contains('active')){
          // if(addButton){
          //   addButton.click();
          // }
        // }
      }
    }
  }
  updateMasterId(){
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia(){
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
      // if(checked_gender.getAttribute('name') != 'Color'){
      //   let stock_ids = document.querySelector('.prod-low-stock').getAttribute('data-ids');
      //   if(stock_ids.includes(checked_gender.getAttribute('data-id'))){
      //     document.querySelector('.prod-low-stock').classList.add('active');
      //   }else{
      //     document.querySelector('.prod-low-stock').classList.remove('active');
      //   }
      //   if(checked_gender.closest('.variant-wrapper').classList.contains('variant-unavailable')){
      //     document.querySelector('.prod-back-stock').classList.add('active');
      //   }else{
      //     document.querySelector('.prod-back-stock').classList.remove('active');
      //   }
      // }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.remove('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.add('hide-selectore-button');
      });
    }else{
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
    }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true){
    const productForm = document.querySelectorAll(`#product-form-${this.dataset.section}`);
    if (!productForm) return;
    productForm.forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      const addButtonText = form.querySelector('[name="add"] > span');
      if(this.currentVariant != undefined){
        if(this.currentVariant.available){
          form.querySelector(".choose-cart").classList.remove('variant_sold-out');
        }else{
          form.querySelector(".choose-cart").classList.add('variant_sold-out');
        }
      }
      if (!addButton) return;
      if (!modifyClass) return;
    })
  }
  setUnavailable(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if(!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData(){
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
if(document.querySelector('.select-mb-prod a')) document.querySelector('.select-mb-prod a').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('body').classList.add('open-mb-size');
  if(document.querySelector('.product-mb-variant .variant-grid.active')) document.querySelector('.product-mb-variant .variant-grid.active').classList.remove('active');
  // document.body.classList.add('add-to-cart');
  // const checkedRadio = document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked');
  // if(checkedRadio){
  //   checkedRadio.checked = false;
  // }
});
if(document.querySelector('.get-notified')) document.querySelector('.get-notified').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('body').classList.remove('open-mb-size');
});
if(document.querySelectorAll('.variant-overly, .variant-popup-close')) document.querySelectorAll('.variant-overly, .variant-popup-close').forEach(function(variant_popup_close) {
  variant_popup_close.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('body').classList.remove('open-mb-size');
    // resetSelectedVariant();
  });
});
if(document.querySelector('.select-mb-prod a')) document.querySelector('.select-mb-prod a').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('body').classList.add('open-mb-size');
});
if(document.querySelectorAll('.variant-overly,.variant-popup-close')) document.querySelectorAll('.variant-overly,.variant-popup-close').forEach(function(variant_popup_close){
  variant_popup_close.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('body').classList.remove('open-mb-size','open-size');
  });
});
// function resetSelectedVariant(){
//   const variantRadios = document.querySelector('variant-radios .option-wrap[data-name="Size"]');
//   if(variantRadios){
//     variantRadios.currentVariant = null;
//     variantRadios.querySelectorAll('input[type="radio"]').forEach(input => {
//       input.checked = false;
//     });
//     if(document.querySelector('variant-radios').dataset.url){
//       const url = new URL(window.location.href);
//       url.searchParams.delete('variant');
//       window.history.replaceState({}, '', url.href);
//     }
//   }
// }
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      var dropdownTrigger = dropdown.querySelector('.variant-dropdown');
      if(!dropdownTrigger) return;
      dropdownTrigger.addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelectorAll('.product-addcart')){
  var counttime = 0;
  function cartNotification(cartId){
    fetch(window.Shopify.routes.root + "?section_id=cart-notification")
    .then((response) => response.text())
    .then((responseText) => {
      const cnID = "cart-notification";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart_popup");
      const source = html.getElementById(cnID);
      if(source && destination) destination.innerHTML = source.innerHTML;
      document.querySelector('body').classList.remove('open-quick-buy');
      let lastItem = document.querySelector(".ch_items .cn_" + cartId).innerHTML;
      if(lastItem) document.querySelector(".ch_items").innerHTML = lastItem;
      if(window.innerWidth > 991){
        if(document.querySelector('body').classList.contains('sticky-filter')){
          if(document.querySelector('body').classList.contains('scroll-down')){
            document.querySelector(".cart_popup").style.top = (document.querySelector('.snippet-collection-filter').offsetHeight+12)+'px';
          }else{
            document.querySelector(".cart_popup").style.top = (document.querySelector('.header-group-wrap').offsetHeight+document.querySelector('.snippet-collection-filter').offsetHeight+12)+'px';
          }
        }else{
          document.querySelector(".cart_popup").style.top = (document.querySelector('.header-group-wrap').offsetHeight+12)+'px';
        }
      }
      if(document.querySelector(".cart-notification")){
        setTimeout(() => {
          // document.querySelector(".cart_popup").classList.add("active");
           document.querySelector("body").classList.add("open-drawer");
        }, 1000);
      }
      counttime = 0;
      const myInterval = setInterval(timer, 1000);
      function timer(){
        counttime++;
        if(counttime > 5){
          document.querySelector(".cart_popup").classList.remove("active");
          setTimeout(() => {
            document.querySelector(".cart_popup").innerHTML = "";
          }, 3000);
          myStop();
        }
      }
      function myStop() {
        clearInterval(myInterval);
      }
      document.body.addEventListener("click", function(e){
        var popup = document.querySelector(".cart_popup");
        if(!popup.contains(event.target)){
          popup.innerHTML = "";
        }
      });
      if(document.querySelector('.cn_close')) document.querySelector('.cn_close').addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector(".cart_popup").classList.remove("active");
        document.querySelector(".cart_popup").innerHTML = "";
      });
      if(document.querySelector('.cn_btn')) document.querySelector('.cn_btn').addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector(".cart_popup").classList.remove("active");
        document.querySelector(".cart_popup").innerHTML = "";
        document.querySelector('body').classList.add('open-drawer');
      });
    });
  }

  document.querySelectorAll('.product-addcart').forEach(function (addToCart) {
    addToCart.addEventListener('click', function (evt) {
      evt.preventDefault();
      function add_cart(){
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var cartForm = addToCart.closest('form');
        if (!cartForm) return;
        const formData = new FormData(cartForm);
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let handledByRecipientForm = false;
              if (window.GiftCardRecipient && typeof window.GiftCardRecipient.showErrors === 'function') {
                handledByRecipientForm = window.GiftCardRecipient.showErrors(response);
              }
              let errorElement = cartForm.querySelector('.product-form-error') || document.querySelector('.product-form-error');
              if (errorElement && !handledByRecipientForm) {
                errorElement.innerHTML = response.description;
                setTimeout(() => {
                  errorElement.innerHTML = '';
                }, 2000);
              }
              return;
            } else {
              document.dispatchEvent(new CustomEvent('cart:added', { detail: response }));
              if (typeof load_cart === 'function') {
                document.body.classList.remove('open-mb-size');
                cartNotification(response.id);
                load_cart();
                checkMultipleSizesAndTriggerPopup();

                setTimeout(() => {
                  // let sizeInput = document.querySelector('.option-wrap[data-name="Size"] .variant-wrapper input:checked');
                  // if (sizeInput) sizeInput.checked = false;
                  // let variantRadios = document.querySelector('variant-radios');
                  // if (variantRadios) {
                  //   window.history.replaceState({}, '', variantRadios.getAttribute('data-url'));
                  // }
                  // let chooseSelector = document.querySelector('.choose-selector');
                  // let chooseCart = document.querySelector('.choose-cart');
                  // if (chooseSelector) chooseSelector.classList.remove('hide-selectore-button');
                  // if (chooseCart) chooseCart.classList.add('hide-selectore-button');
                }, 1000);
              } else {
                window.location.href = "/cart";
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
      if(window.innerWidth < 992){
        // if(document.body.classList.contains('add-to-cart') || addToCart.querySelector('.prod-one-size')){
          add_cart();
        // }
      }else{
        add_cart();
      }
    });
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto'
    });
    var swiper2 = new Swiper(".media-nav", {
      loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelectorAll('.product-info .pdp-more-color')) document.querySelectorAll('.product-info .pdp-more-color').forEach(function(color_btn){
  color_btn.addEventListener('click',function(e){
    e.preventDefault();
    color_btn.closest('.product-info').classList.add('open-color-list');
  });
});
if(document.querySelectorAll('.close-color-list,.pdp-color-overly')) document.querySelectorAll('.close-color-list,.pdp-color-overly').forEach(function(list_close_btn){
  list_close_btn.addEventListener('click',function(e){
    e.preventDefault();
    list_close_btn.closest('.product-info').classList.remove('open-color-list');
  });
});
// if(document.querySelector('.initial-sticky-cta')){
//   if(window.innerWidth < 992){
//     document.querySelector('.initial-sticky-cta a').addEventListener('click', doScrolling.bind(null, '.snippet-product-add-cart-variant', 2000))
//   }
// }
if(document.querySelector('.one-size-sticky-add')) document.querySelector('.one-size-sticky-add').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('.product-addcart').click();
});
document.addEventListener("DOMContentLoaded", function(){
  let stickyCTA = document.querySelector('.initial-sticky-cta');
  let scrollTarget = document.querySelector('.snippet-addto-cart');
  let ctaButton = document.querySelector('.initial-sticky-cta a, .initial-sticky-cta button');
  let header = document.querySelector('.header-group');
  if(ctaButton) ctaButton.addEventListener('click', function(e){
    e.preventDefault();
    if(document.querySelector('.variant-popup')){
      document.querySelector('body').classList.add('open-size');
    }else if(document.querySelector('.variant-wrapper[data-val="one-size"]')){
      document.querySelector('.product-addcart').click();
    }else{
      if (scrollTarget){
        let headerHeight = header ? header.offsetHeight : 0;
        let offsetFromTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
        let extraOffset = window.innerHeight * 0.3;
        let scrollToPosition = offsetFromTop - headerHeight - extraOffset;
        window.scrollTo({top: scrollToPosition,behavior: 'smooth'});
      }
      stickyCTA.classList.remove('show-initial-sticky');
    }
  });
  function isTargetVisible(el){
    let rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }
  function isAboveTarget(el){
    let rect = el.getBoundingClientRect();
    return rect.top > 0;
  }
  function handleScroll(){
    if(window.pageYOffset > 0){
      document.body.classList.add('sticky_initial');
    }else{
      document.body.classList.remove('sticky_initial');
    }
    if(isTargetVisible(scrollTarget)){
      stickyCTA.classList.remove('show-initial-sticky');
    }else if(isAboveTarget(scrollTarget)){
      stickyCTA.classList.add('show-initial-sticky');
    }else{
      stickyCTA.classList.remove('show-initial-sticky');
    }
  }
  handleScroll();
  window.addEventListener('scroll', handleScroll);
});
// if(document.querySelectorAll('.choose-selector a')) document.querySelectorAll('.choose-selector a').forEach(function(choose_selector){
//   choose_selector.addEventListener('click', function(e){
//     e.preventDefault();
//     console.log('clickedddd');
//     alert('clickedddd');
//     if(window.innerWidth < 992){
//       choose_selector.classList.add('abc');
//     }
//   });
// });
if(document.querySelector('.product-info-inr .choose-selector a')) document.querySelector('.product-info-inr .choose-selector a').addEventListener('click', function(e){
  e.preventDefault();
  if(window.innerWidth < 992){
    if(!document.querySelector('.option-wrap[data-name="Size"] .variant-row-list input[type="radio"]:checked')){
      document.querySelector('.product-info-inr .choose-selector a').classList.add('select_size');
    }else{
      document.querySelector('.product-info-inr .choose-selector a').classList.remove('select_size');
    }
  }
});
// document.addEventListener('click', function(e){
//   const target = e.target.closest('.product-info-inr .choose-selector a');
//   if(target){
//     e.preventDefault();
//     console.log('clickedddd');

//     if(window.innerWidth < 992){
//       const selectedSize = document.querySelector('.option-wrap[data-name="Size"] .variant-row-list input[type="radio"]:checked');
//       if(!selectedSize){
//         target.classList.add('select_size');
//       } else {
//         target.classList.remove('select_size');
//       }
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelector('.prod-more-item')){
    if(window.innerWidth > 991){
      document.querySelector('.prod-more-item a').addEventListener('click', function (e){
        e.preventDefault();
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;
        const targetElement = document.querySelector('.section-product-recommendations');
        if(targetElement){
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
          smoothScrollTo(window.scrollY, targetPosition, 2000);
        }
      });
    }
  }
  function smoothScrollTo(start, end, duration){
    const distance = end - start;
    const startTime = performance.now();
    function scrollAnimation(currentTime){
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeInOutQuad(progress);
      window.scrollTo(0, start + distance * ease);
      if(progress < 1) requestAnimationFrame(scrollAnimation);
    }
    requestAnimationFrame(scrollAnimation);
  }
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
  // if(document.querySelector('.prod-more-item')){
  //   if(window.innerWidth > 991){
  //     document.querySelector('.prod-more-item a').addEventListener('click', doScrolling.bind(null, 'product-recommendations', 2000))
  //   }
  // }
  if(document.querySelector('.sticky_select_size')){
    document.querySelector('.sticky_select_size a').addEventListener('click', doScrolling.bind(null, '.product-wrap', 2000))
  }
  if(document.querySelector('.select_size')) document.querySelector('.select_size').addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('body').classList.add('open-size');
  });
  if(document.querySelector('.variant-popup-overly')) document.querySelector('.variant-popup-overly').addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('body').classList.remove('open-size');
  });
  if(document.querySelectorAll('.sticky-variant-inr a')) document.querySelectorAll('.sticky-variant-inr a').forEach(function(sticky_variant){
    sticky_variant.addEventListener('click', function(e){
      e.preventDefault();
      let id = sticky_variant.getAttribute('data-id');
      document.querySelectorAll('.sticky-variant-inr li').forEach(function(sticky_variant_active){
        sticky_variant_active.classList.remove('active');
      });
      sticky_variant.closest('li').classList.add('active');
      document.querySelectorAll('.variant-wrapper').forEach(function(variant_list){
        let all_id = variant_list.getAttribute('data-variant-id');
        if(id == all_id){
          variant_list.querySelector('input').click();
        }
      });
    });
  });
  if(document.querySelectorAll('.popup-varinat-wrap')[0]) document.querySelectorAll('.popup-varinat-wrap')[0].querySelectorAll('li a').forEach(function(waistOption) {
    if (waistOption.getAttribute('data-val') === document.querySelector('.popup-varinat-wrap[data-current-waist]').getAttribute('data-current-waist')) {
      waistOption.closest('li').classList.add('active');
    }
  });
  if(document.querySelectorAll('.popup-varinat-wrap')[1]) document.querySelectorAll('.popup-varinat-wrap')[1].querySelectorAll('li a').forEach(function(lengthOption) {
    if (lengthOption.getAttribute('data-val') === document.querySelector('.popup-varinat-wrap[data-current-lenght]').getAttribute('data-current-lenght')) {
      lengthOption.closest('li').classList.add('active');
    }
  });
  // const unavailableVariants = document.querySelector('.popup-varinat-wrap').dataset.unavailableVariants.split(',');
  // function updateAvailability() {
  //   let selectedWaist = document.querySelectorAll('.popup-varinat-wrap')[0].querySelector('li.active a')?.getAttribute('data-val');
  //   let selectedLength = document.querySelectorAll('.popup-varinat-wrap')[1].querySelector('li.active a')?.getAttribute('data-val');
  //   let waistOptions = document.querySelectorAll('.popup-varinat-wrap')[0].querySelectorAll('li a');
  //   let lengthOptions = document.querySelectorAll('.popup-varinat-wrap')[1].querySelectorAll('li a');
  //   if(selectedWaist){
  //     lengthOptions.forEach(function(lengthOption){
  //       let length = lengthOption.getAttribute('data-val');
  //       let variant = `${selectedWaist}/${length}`;
  //       if(unavailableVariants.includes(variant)){
  //         lengthOption.classList.add('unavailable');
  //       } else {
  //         lengthOption.classList.remove('unavailable');
  //       }
  //     });
  //   }
  //   if (selectedLength){
  //     waistOptions.forEach(function(waistOption) {
  //       let waist = waistOption.getAttribute('data-val');
  //       let variant = `${waist}/${selectedLength}`;
  //       if(unavailableVariants.includes(variant)){
  //         waistOption.classList.add('unavailable');
  //       } else {
  //         waistOption.classList.remove('unavailable');
  //       }
  //     });
  //   }
  // }
  // updateAvailability();
  const popupVariantWrap = document.querySelector('.popup-varinat-wrap');
  if (popupVariantWrap) {
    const unavailableVariants = popupVariantWrap.dataset.unavailableVariants?.split(',') || [];
    function updateAvailability() {
      let waistWrap = document.querySelectorAll('.popup-varinat-wrap')[0];
      let lengthWrap = document.querySelectorAll('.popup-varinat-wrap')[1];
      if (!waistWrap || !lengthWrap) return;
      let selectedWaist = waistWrap.querySelector('li.active a')?.getAttribute('data-val');
      let selectedLength = lengthWrap.querySelector('li.active a')?.getAttribute('data-val');
      let waistOptions = waistWrap.querySelectorAll('li a');
      let lengthOptions = lengthWrap.querySelectorAll('li a');
      if (selectedWaist) {
        lengthOptions.forEach(lengthOption => {
          let length = lengthOption.getAttribute('data-val');
          let variant = `${selectedWaist}/${length}`;
          lengthOption.classList.toggle('unavailable', unavailableVariants.includes(variant));
        });
      }
      if (selectedLength) {
        waistOptions.forEach(waistOption => {
          let waist = waistOption.getAttribute('data-val');
          let variant = `${waist}/${selectedLength}`;
          waistOption.classList.toggle('unavailable', unavailableVariants.includes(variant));
        });
      }
    }
    updateAvailability();
  }
  if(document.querySelectorAll('.variant-popup-inr a')) document.querySelectorAll('.variant-popup-inr a').forEach(function(popup_variant_btn){
    popup_variant_btn.addEventListener('click', function(e){
      e.preventDefault();
      popup_variant_btn.closest('.popup-varinat-wrap').querySelectorAll('li').forEach(function(popup_active_rm){
        popup_active_rm.classList.remove('active');
      });
      popup_variant_btn.closest('li').classList.add('active');
      updateAvailability();
      let color = popup_variant_btn.closest('.popup-variant').querySelector('.option-color a').getAttribute('data-val');
      let val = popup_variant_btn.getAttribute('data-val');
      let join_val = '';
      if(document.querySelectorAll('.popup-varinat-wrap')[0].querySelector('li.active a')){
        join_val = document.querySelectorAll('.popup-varinat-wrap')[0].querySelector('li.active a').getAttribute('data-val')
      }
      if(document.querySelectorAll('.popup-varinat-wrap')[1].querySelector('li.active a')){
        join_val = join_val + '/' + document.querySelectorAll('.popup-varinat-wrap')[1].querySelector('li.active a').getAttribute('data-val');
      }
      let variant = color + ' / ' + join_val
      document.querySelectorAll('.product-variant-select option').forEach(function(popup_variant_select){
        if(variant == popup_variant_select.textContent){
          document.querySelector('.popup-choose-selector').classList.remove('hide-selectore-button');
          document.querySelector('.popup-select-size').classList.add('hide-selectore-button');
          document.querySelector('.product-variant-select').selectedIndex = popup_variant_select.index;
          document.querySelector('.product-variant-select').dispatchEvent(new Event('change'));
          window.history.replaceState({ }, '', `${popup_variant_btn.closest('.popup-variant').getAttribute('data-url')}?variant=${popup_variant_select.value}`);
          popup_variant_btn.closest('form').querySelector('input[name="id"]').value = popup_variant_select.value;
          if(popup_variant_select.getAttribute('disabled') != null){
            document.querySelector('.popup-choose-selector').classList.add('variant_sold-out');
          }else{
            document.querySelector('.popup-choose-selector').classList.remove('variant_sold-out');
          }
          if(!document.querySelector('.popup-choose-selector').classList.contains('variant_sold-out') && window.innerWidth <= 991){
            if(document.querySelector('.popup-add-cart')) document.querySelector('.popup-add-cart').click();
          }
        }
      });
    })
  })
  if(document.querySelector('.popup-add-cart')) document.querySelector('.popup-add-cart').addEventListener('click',function(evt){
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var cartform = document.querySelector('.popup-add-cart').closest('form');
    const formData = new FormData(cartform);  
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.querySelector('.popup-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.popup-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          checkMultipleSizesAndTriggerPopup();
          if(window.innerWidth <= 991){
            document.querySelector('body').classList.remove('open-mb-size');
            cartNotification(response.id);
          }else{
            setTimeout(function(e){
              document.querySelector('body').classList.remove('open-size');
              document.querySelector('body').classList.add('open-drawer');
            },500);
          }
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
  
    });
  });
});
window.addEventListener('scroll', function(){
  var scrollDistance = window.scrollY;
  if(scrollDistance > 0){
    document.querySelector('body').classList.add('scrolling');
  }else{
    document.querySelector('body').classList.remove('scrolling');
  }
  if(window.innerWidth >= 992){
    document.querySelectorAll('.pdp-media-column').forEach(function(element, index){
      const offset = window.innerHeight * 0.8;
      let height = parseInt(
        (element.getBoundingClientRect().top + scrollDistance) -
        document.querySelector('.header-group').offsetHeight
      );
  
      if (height <= scrollDistance + offset) {
        document.querySelector('.pdp-thumb.active')?.classList.remove('active');
        document.querySelectorAll('.pdp-thumb')[index]?.classList.add('active');
      }
    });
  }else{
    if(scrollDistance >= (document.querySelector('.product-info').offsetTop - document.querySelector('.header-group').offsetHeight)){
      document.body.classList.add('product-solid-header');
    }else{
      document.body.classList.remove('product-solid-header');
    }
  }
});
function smoothScrollTo(targetY, duration){
  const startY = window.scrollY || document.documentElement.scrollTop;
  const distance = targetY - startY;
  let startTime = null;
  function animationStep(timestamp){
    if(!startTime) startTime = timestamp;
    const timeElapsed = timestamp - startTime;
    const progress = Math.min(timeElapsed / duration, 1); // Ensure progress never exceeds 1
    window.scrollTo(0, startY + distance * easeInOutQuad(progress));
    if(timeElapsed < duration){
      requestAnimationFrame(animationStep);
    }
  }
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }
  requestAnimationFrame(animationStep);
}
document.querySelectorAll('.pdp-thumb a').forEach(anchor => {
  anchor.addEventListener('click', function(e){
    e.preventDefault();
    const dataIndex = this.getAttribute('data-index');
    const targetElement = document.querySelector('.pdp-media-column[data-index="' + dataIndex + '"]');
    if(targetElement){
      smoothScrollTo(targetElement.offsetTop, 600); // Scroll smoothly over 600ms
    }
  });
});
// if(document.querySelectorAll('.pdp-thumb a')) document.querySelectorAll('.pdp-thumb a').forEach(function(anchor){
//   anchor.addEventListener('click', function(e) {
//     e.preventDefault();
//     var dataIndex = this.getAttribute('data-index');
//     var targetElement = document.querySelector('.pdp-media-column[data-index="' + dataIndex + '"]');
//     if (targetElement) {
//       // var headerHeight = document.querySelector('.header-group').offsetHeight;
//       window.scrollTo({
//         // top: targetElement.offsetTop - headerHeight,
//         top: targetElement.offsetTop,
//         behavior: 'smooth'
//       });
//     }
//   });
// });
function initDrawer({ trigger, bodyClass, closeSelectors, lockScroll, wrapper, inner }) {
  const triggerEl = document.querySelector(trigger);
  if (triggerEl) {
    triggerEl.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.add(bodyClass);
      if (lockScroll) {
        document.body.style.touchAction = 'none';
        document.body.style.overscrollBehavior = 'none';
      }
    });
  }
  document.querySelectorAll(closeSelectors).forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove(bodyClass);
      if (lockScroll) {
        document.body.style.touchAction = '';
        document.body.style.overscrollBehavior = '';
      }
    });
  });
  if (wrapper && inner) {
    const wrapperEl = document.querySelector(wrapper);
    if (wrapperEl) {
      wrapperEl.addEventListener('scroll', function() {
        const innerEl = document.querySelector(inner);
        if (innerEl && window.innerHeight * 0.8 < innerEl.offsetHeight) {
          wrapperEl.style.height = innerEl.offsetHeight + 'px';
          wrapperEl.style.maxHeight = '100dvh';
        }
      });
    }
  }
}
initDrawer({ trigger: '.product-detail', bodyClass: 'open-product-details', closeSelectors: '.pd_close,.product-details-overly', lockScroll: true, wrapper: '.product-details-wrapper', inner: '.pd-inr' });
initDrawer({ trigger: '.shipping-returns-trigger', bodyClass: 'open-shipping-returns', closeSelectors: '.sr_close,.shipping-returns-overlay', lockScroll: true, wrapper: '.shipping-returns-wrapper', inner: '.sr-inr' });
initDrawer({ trigger: '.more-responsible-title', bodyClass: 'open-responsible', closeSelectors: '.mr_close,.responsible-overly' });
initDrawer({ trigger: '.product-size-guide', bodyClass: 'open-size-chart', closeSelectors: '.size_chart_close,.size-chart-overly,.easysize-widget' });
document.addEventListener('DOMContentLoaded', () => {
  let splideList = document.querySelector('.media-grid');
  let mediaColumns = document.querySelectorAll('.pdp-media-column');
  let mediaCount = document.querySelector('.product-media-count');
  if (splideList && mediaColumns.length && mediaCount){
    const updateMediaCount = () => {
      let listRect = splideList.getBoundingClientRect();
      let activeIndex = 0;
      mediaColumns.forEach((media, index) => {
        let mediaRect = media.getBoundingClientRect();
        let mediaCenter = mediaRect.left + mediaRect.width / 2;
        if (mediaCenter >= listRect.left && mediaCenter <= listRect.right){
          activeIndex = index;
        }
      });
      mediaCount.textContent = `${activeIndex + 1}/${mediaColumns.length}`;
    };
    updateMediaCount();
    splideList.addEventListener('scroll', updateMediaCount);
  }
  if(document.querySelectorAll('.prod-media-model')) document.querySelectorAll('.prod-media-model').forEach(function(pd_model){
    setTimeout(() => {
      pd_model.classList.add('active-model');
    }, 1000);
  });
});
function updSwiperNumericPagination(){
  document.querySelector(".product-media-count").innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + this.slides.length + "</span>";
}

document.addEventListener('DOMContentLoaded', function () {
  let swiperEl = document.querySelector('.media-grid');
  let countDiv = document.querySelector('.product-media-count');

  let swiper = new Swiper(swiperEl, {
    slidesPerView: 1,  // Ensures only one slide is visible at a time
    slidesPerGroup: 1, // Moves only one slide at a time
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    allowTouchMove: true, // Allows touch/drag to move one slide at a time
    navigation: false, // No arrows (same as `arrows: false` in Splide)
    breakpoints: {
      992: {
        enabled: false, // Disable Swiper on screens ≥ 992px
      }
    },
    on: {
      init: function () {
        updateCounter(this);
      },
      slideChange: function () {
        updateCounter(this);
      }
    }
  });

  function updateCounter(swiper) {
    let totalSlides = swiper.slides.length;
    let currentIndex = swiper.realIndex + 1;
    countDiv.textContent = `${currentIndex}/${totalSlides}`;
  }
});

// document.addEventListener('DOMContentLoaded', function(){
//   let splide = document.querySelector('.media-grid');
//   let bar = splide.querySelector('.product-media-progress');
//   let countDiv = document.querySelector('.product-media-count');
//   splide = new Splide(splide, {
//     mediaQuery: 'min',
//     arrows: false,
//     perPage: 1,
//     perMove: 1,
//     pagination : true,
//     breakpoints: {
//       992: {
//         destroy: true,
//       }
//     }
//   });
//   splide.on('mounted move', function(){
//     var end = splide.Components.Controller.getEnd() + 1;
//     let currentIndex = splide.index + 1;
//     countDiv.textContent = `${currentIndex}/${end}`;
//   });
//   splide.mount();
// });
window.addEventListener('scroll', function(){
  var body = document.body;
  var stickyClass = 'stickybar';
  var scrollDistance = window.scrollY;
  // if(window.matchMedia('(min-width: 992px)').matches){
    var div = document.querySelector('.snippet-addto-cart');
    if(!div) return;
    var rect = div.getBoundingClientRect();
    var topOffset = rect.top;
    if(topOffset <= 0){
      var sectionFooter = document.querySelector('.footer-group');
      if(!sectionFooter) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
      var buttons = document.querySelectorAll('.snippet-sticky-product-cart');
      buttons.forEach(function(button){
        if(section < 0){
          body.classList.remove(stickyClass);
        }else{
          body.classList.add(stickyClass);
        }
      });
    }else{
      body.classList.remove(stickyClass);
    }
  // }else if(window.matchMedia('(max-width: 991px)').matches){
  //   var mobileDiv = document.querySelector('.select-mb-prod');
  //   if(!mobileDiv) return;
  //   var rectMobile = mobileDiv.getBoundingClientRect();
  //   var topOffsetMobile = rectMobile.top;
  //   if(scrollDistance > 0){
  //     var sectionFooter = document.querySelector('.footer-group');
  //     if(!sectionFooter) return;
  //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  //     var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
  //     if(section < 0){
  //       body.classList.remove(stickyClass);
  //     }else{
  //       body.classList.add(stickyClass);
  //     }
  //   }else{
  //     body.classList.remove(stickyClass);
  //   }
  // }
});
document.querySelectorAll('.product-info-inr .grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(window.innerWidth > 991){
      if(color.querySelector('a') != null && document.querySelector('.color-name') != null){
        let colorName = color.querySelector('a').getAttribute('data-val')
        document.querySelector('.color-name').textContent = colorName
      }
    }
  })
  color.addEventListener('mouseout',function(){
    if(window.innerWidth > 991){
      if(color.querySelector('a') != null && document.querySelector('.color-name') != null){
        document.querySelector('.color-name').textContent = document.querySelector('.product-info-inr  .grid-meta-color li.active a').getAttribute('data-val')
      }
    }
  })
})
// document.addEventListener('DOMContentLoaded', () => {
//   const currentWaist = document.getElementById('current-waist').value;
//   const currentLength = document.getElementById('current-length').value;
//   console.log(currentWaist, currentLength);
//   document.querySelectorAll('.popup-varinat-wrap')[0].querySelectorAll('li a').forEach(function(waistOption) {
//     if (waistOption.getAttribute('data-val') === currentWaist) {
//       waistOption.closest('li').classList.add('active');
//     }
//   });
//   document.querySelectorAll('.popup-varinat-wrap')[1].querySelectorAll('li a').forEach(function(lengthOption) {
//     if (lengthOption.getAttribute('data-val') === currentLength) {
//       lengthOption.closest('li').classList.add('active');
//     }
//   });
// });

function simulateClickOnTracerMapText() {
  const element = document.querySelector('.tracer-map__text p');
  if (element) {
    element.click();
  } else {
    console.error("Element '.tracer-map__text p' not found.");
  }
}

document.querySelector('.track-item-text').addEventListener('click', simulateClickOnTracerMapText);

